<template lang="pug">
.slidercaptcha.card
  .card-header
    span {{ $t("ui.drag_to_verify") }}
  .card-body
    #captcha
</template>

<script>
import config from "@/config";

export default {
  mounted: function() {
    var captcha = sliderCaptcha({
      id: 'captcha',
      repeatIcon: 'fa fa-redo',
      // width: 380,
      // height: 155,
      loadingText: this.$t("ui.loading"),
      barText: this.$t("ui.slide_puzzle"),
      setSrc:function () {
        return config.resourceImgUrl + '/agent/img/Pic' + Math.round((Math.random() * 5) + 1) +'.jpg';
      },
      onSuccess: () => {
        var handler = setTimeout(() => {
          window.clearTimeout(handler);
          captcha.reset();
          this.$emit("click")
        }, 500);
      }
    });
  }
}

</script>